import { Component } from '@angular/core';
import { NavController, Events, LoadingController } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBase } from '../../../../core/page-base';
import { AppSettings } from '../../../../config/app-settings';
import { HomeCommon } from './home.common';
import { RecipeDetailPage } from '../../../recipes/pages/recipe-detail/recipe-detail';

import _ from 'lodash';

@Component({
	selector: 'page-home',
  	templateUrl: 'home.html'
})

export class HomePage extends PageBase {
	public pageSections:any;
	public loader: any;

	constructor(
		public settings: AppSettings,
		public events: Events,
		public nav: NavController,
		public userData: UserData,
		public common: HomeCommon,
        public loadingCtrl: LoadingController
	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
	}

	ngAfterViewInit() {
		let self = this;
		self.loader.present();
		self.common.getHomeWidgets().subscribe((sections) =>{
			_.forEach(sections, function(section){
				if(section.type==='recipe-features'){
					console.log(section);
					section.data = _.chunk(section.data, 2);
				}
			});

			self.pageSections = sections;
			
			self.loader.dismiss();
		});
	}

	ionViewDidEnter() {
		
	}

	viewRecipeDetail(id) {
	    this.nav.push(RecipeDetailPage, { id: id });
	}
}





// WEBPACK FOOTER //
// ./src/modules/home/pages/home/home.ts